import * as contentstack from 'contentstack';

import ContentstackLivePreview from '@contentstack/live-preview-utils';
import * as Utils from '@contentstack/utils';

const Stack = contentstack.Stack({
    api_key: process.env.REACT_APP_CONTENTSTACK_API_KEY,
    delivery_token: process.env.REACT_APP_CONTENTSTACK_DELIVERY_TOKEN,
    environment: process.env.REACT_APP_CONTENTSTACK_ENVIRONMENT,

    live_preview: {
        preview_token: process.env.REACT_APP_CONTENTSTACK_PREVIEW_TOKEN,
        enable: false,
        host: process.env.REACT_APP_CONTENTSTACK_API_HOST,
    },
});

Stack.setHost(`${process.env.REACT_APP_CONTENTSTACK_API_HOST}`);

ContentstackLivePreview.init({
    enable: false,
    stackSdk: Stack,
    clientUrlParams: {
        host: process.env.REACT_APP_CONTENTSTACK_APP_HOST
    },
    ssr: false,
});

const renderOption = {
  ['span']: (node, next) => {
    return next(node.children);
  },
};

export const onEntryChange = ContentstackLivePreview.onEntryChange;


export default {  
    /**
     *fetches specific entry from a content-type
     *
     * @param {* content-type uid} contentTypeUid
     * @param {* url for entry to be fetched} entryUrl
     * @param {* reference field name} referenceFieldPath
     * @param {* Json RTE path} jsonRtePath
     * @returns
     */
    getEntryByUrl({ contentTypeUid, entryUrl, referenceFieldPath, jsonRtePath }) {
      return new Promise((resolve, reject) => {
        const blogQuery = Stack.ContentType(contentTypeUid).Query();
        if (referenceFieldPath) blogQuery.includeReference(referenceFieldPath);
        blogQuery.includeOwner().toJSON();
        const data = blogQuery.where('url', `${entryUrl}`).find();
        data.then(
          (result) => {
            jsonRtePath &&
              Utils.jsonToHTML({
                entry: result,
                paths: jsonRtePath,
                renderOption,
              });
            resolve(result[0]);
          },
          (error) => {
            reject(error);
          },
        );
      });
    },
  };
  